import { StatementCollectionModel } from "@bToC/Services/GerrieApiModels";
import { getStatements, GetStatementsApiParameter } from "@bToC/Services/StatementService";
import { CustomActions, CustomState } from "@bToC/Store/Reducers";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<
    GetStatementsApiParameter,
    StatementCollectionModel,
    {
        apiCallIsSuccessful: boolean;
        getState: () => CustomState;
    } & DispatchProp<CustomActions>
>;

export const DispatchBeginLoadStatementData: HandlerType = props => {
    props.dispatch({
        type: "Data/Statement/BeginLoadStatementData",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getStatements(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Data/Statement/FailedToLoadStatements" });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadStatementData: HandlerType = props => {
    props.dispatch({
        type: "Data/Statement/CompleteLoadStatementData",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, DispatchBeginLoadStatementData, RequestDataFromApi, DispatchCompleteLoadStatementData];

export const loadStatementData = createHandlerChainRunner(chain, "LoadStatementData");
export default loadStatementData;
